<template>
  <div>
    <div class="form-group">
      <slot name="actions"></slot>
    </div>
    <div class="ajuste-overflow">
      <header>
        <div>
          <slot name="header-actions"></slot>
        </div>
        <div>
          <vuetable-length-change
            class="custom-api-table-font"
            :per-page="perPage"
            :options="[10, 20, 30, 50, 100, 200, 300, 'Todos']"
            @updatePerPage="updatePerPage"
          />
        </div>
      </header>

      <vue-table
        ref="vuetable"
        class="custom-api-table-font"
        :api-mode="false"
        :fields="fields"
        :data-total="dataCount"
        :data-manager="dataManager"
        pagination-path="pagination"
        :per-page="perPage"
        :css="css.table"
        :no-data-template="
          carregando ? 'Carregando Informações' : 'Nenhum item encontrado!'
        "
        @vuetable:pagination-data="onPaginationData"
        @vuetable:row-clicked="onRowClicked"
      >
        <!-- <template slot="icon" slot-scope="props">
          <slot name="icon" :rowData="props.rowData"></slot>
        </template>  -->

        <template slot="input" slot-scope="props">
          <slot name="column_input" :rowData="props.rowData"></slot>
        </template>

        <template slot="column" slot-scope="props">
          <slot name="columncustom" :rowData="props.rowData"></slot>
        </template>

        <template v-for="item in slots" :slot="item" slot-scope="props">
          <slot
            :name="item"
            :rowData="props.rowData"
            :rowIndex="props.rowIndex"
          ></slot>
        </template>

        <template slot="actions" slot-scope="props">
          <slot name="rowrender" :rowData="props.rowData"></slot>
        </template>
      </vue-table>
    </div>

    <pagination
      ref="pagination"
      :css="css.pagination"
      :icons="css.icons"
      @vuetable-pagination:change-page="onChangePage"
    />

    <pagination-info
      ref="paginationInfo"
      :css="css.paginationInfo"
      info-template="Registro(s) {from} ao {to} de um total de {total}"
      no-data-template="Nenhum registro"
      class="pull-left custom-api-table-font"
    >
    </pagination-info>

    <div class="clearfix"></div>
  </div>
</template>

<script>
import VueTable from 'vuetable-2/src/components/Vuetable'
import pagination from 'vuetable-2/src/components/VuetablePagination'
import PaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import VuetableLengthChange from './VuetableLengthChange.vue'

export default {
  components: {
    VueTable,
    pagination,
    PaginationInfo,
    VuetableLengthChange
  },
  props: {
    dados: {
      type: Array,
      required: true
    },
    slots: {
      type: Array,
      default: () => []
    },
    fields: {
      type: Array,
      required: true
    },
    per_page: {
      type: Number,
      default: 10
    },
    carregando: {
      type: Boolean,
      default: true
    },
    onRowClicked: {
      type: Function,
      default() {
        return
      }
    },
    onPaginationChangePage: {
      type: Function,
      default() {
        return
      }
    }
  },
  data() {
    return {
      localData: [],
      dataCount: 0,
      css: {
        table: {
          tableClass: 'table table-striped table-hover',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          loadingClass: 'fa fa-spinner fa-spin'
        },
        pagination: {
          wrapperClass: 'pagination pull-right',
          activeClass: 'btn-primary',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: 'glyphicon glyphicon-step-backward',
            prev: 'glyphicon glyphicon-chevron-left',
            next: 'glyphicon glyphicon-chevron-right',
            last: 'glyphicon glyphicon-step-forward'
          }
        }
      },
      perPage: 0
    }
  },
  watch: {
    dados(newVal, oldVal) {
      this.localData = newVal
      this.$refs.vuetable.refresh()
    }
  },
  created() {
    this.localData = this.dados
    this.dataCount = this.localData.length
    this.perPage = this.per_page
  },
  mounted() {
    this.$refs.vuetable.setData(this.localData)
    this.$refs.vuetable.refresh()

    this.tablePagination = this.$refs.vuetable.tablePagination
  },
  computed: {
    tableData() {
      return this.$refs.vuetable.tableData
    }
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page)
      this.$emit('vuetable-pagination:change-page')
    },
    dataManager(sortOrder, pagination) {
      let data = this.localData

      // account for search filter
      if (this.searchFor) {
        // the text should be case insensitive
        let txt = new RegExp(this.searchFor, 'i')

        // search on name, email, and nickname
        data = _.filter(data, function(item) {
          return (
            item.name.search(txt) >= 0 ||
            item.email.search(txt) >= 0 ||
            item.nickname.search(txt) >= 0
          )
        })
      }

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        data = _.orderBy(data, sortOrder[0].sortField, sortOrder[0].direction)
      }

      // since the filter might affect the total number of records
      // we can ask Vuetable to recalculate the pagination for us
      // by calling makePagination(). this will make VuetablePagination
      // work just like in API mode
      pagination = this.$refs.vuetable.makePagination(data.length)

      // if you don't want to use pagination component, you can just
      // return the data array
      return {
        pagination: pagination,
        data: _.slice(data, pagination.from - 1, pagination.to)
      }
    },
    updatePerPage(value) {
      this.perPage = value === 0 ? this.dados.length : value
      this.$nextTick(() => this.$refs.vuetable.refresh())
    }
  }
}
</script>

<style scoped>
.ajuste-overflow {
  overflow: auto;
}

.custom-api-table-font {
  color: #002220;
}

header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 5px;
}

/* header div:first-child {
  flex: 9;
} */

/* header div:last-child {
  flex: 1;
} */
</style>



// WEBPACK FOOTER //
// src/components/common/NoApiTable/index.vue